// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SharedUpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel {
    static getAttributeTypeMap() {
        return SharedUpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel.attributeTypeMap;
    }
}
SharedUpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel.discriminator = undefined;
SharedUpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel.additionalProperties = false;
SharedUpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel.attributeTypeMap = [
    {
        "name": "canUpdate",
        "baseName": "canUpdate",
        "type": "boolean"
    },
    {
        "name": "canInsert",
        "baseName": "canInsert",
        "type": "boolean"
    },
    {
        "name": "skipSearch",
        "baseName": "skipSearch",
        "type": "boolean"
    },
    {
        "name": "model",
        "baseName": "model",
        "type": "EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel"
    },
];
//# sourceMappingURL=sharedUpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel.js.map